export const locations = [
  {
    id: 'pattaya',
    name: {
      ko: '파타야', en: 'Pattaya', zh: '芭提雅', ja: 'パタヤ',
      th: 'พัทยา', fr: 'Pattaya', de: 'Pattaya', es: 'Pattaya',
    },
    description: {
      ko: '태국 동부 해안의 활기찬 리조트 도시',
      en: 'A vibrant resort city on Thailand\'s eastern coast',
      zh: '泰国东海岸充满活力的度假城市',
      ja: 'タイ東海岸の活気あるリゾート都市',
      th: 'เมืองรีสอร์ทที่มีชีวิตชีวาบนชายฝั่งตะวันออกของไทย',
      fr: 'Une ville balnéaire animée sur la côte est de la Thaïlande',
      de: 'Eine lebhafte Ferienstadt an Thailands Ostküste',
      es: 'Una vibrante ciudad turística en la costa este de Tailandia',
    },
    image: '🏖️',
    lat: 12.9236,
    lng: 100.8825,
  },
  {
    id: 'phuket',
    name: {
      ko: '푸켓', en: 'Phuket', zh: '普吉岛', ja: 'プーケット',
      th: 'ภูเก็ต', fr: 'Phuket', de: 'Phuket', es: 'Phuket',
    },
    description: {
      ko: '안다만 해의 아름다운 섬',
      en: 'A beautiful island in the Andaman Sea',
      zh: '安达曼海的美丽岛屿',
      ja: 'アンダマン海の美しい島',
      th: 'เกาะสวยงามในทะเลอันดามัน',
      fr: 'Une belle île dans la mer d\'Andaman',
      de: 'Eine wunderschöne Insel in der Andamanensee',
      es: 'Una hermosa isla en el mar de Andamán',
    },
    image: '🌴',
    lat: 7.8804,
    lng: 98.3923,
  },
  {
    id: 'bangkok',
    name: {
      ko: '방콕', en: 'Bangkok', zh: '曼谷', ja: 'バンコク',
      th: 'กรุงเทพฯ', fr: 'Bangkok', de: 'Bangkok', es: 'Bangkok',
    },
    description: {
      ko: '태국의 수도, 문화와 활력의 중심지',
      en: 'Thailand\'s capital, a hub of culture and vitality',
      zh: '泰国首都，文化与活力的中心',
      ja: 'タイの首都、文化と活力の中心地',
      th: 'เมืองหลวงของไทย ศูนย์กลางวัฒนธรรมและความมีชีวิตชีวา',
      fr: 'La capitale de la Thaïlande, un centre de culture et de vitalité',
      de: 'Thailands Hauptstadt, ein Zentrum der Kultur und Vitalität',
      es: 'La capital de Tailandia, un centro de cultura y vitalidad',
    },
    image: '🏙️',
    lat: 13.7563,
    lng: 100.5018,
  },
  {
    id: 'korat',
    name: {
      ko: '코랏', en: 'Korat', zh: '呵叻', ja: 'コラート',
      th: 'โคราช', fr: 'Korat', de: 'Korat', es: 'Korat',
    },
    description: {
      ko: '이산 지역의 관문 도시',
      en: 'The gateway city to the Isan region',
      zh: '伊森地区的门户城市',
      ja: 'イサーン地方への玄関都市',
      th: 'เมืองประตูสู่ภาคอีสาน',
      fr: 'La ville porte de la région d\'Isan',
      de: 'Die Tor-Stadt zur Isan-Region',
      es: 'La ciudad puerta de entrada a la región de Isan',
    },
    image: '🏯',
    lat: 14.9799,
    lng: 102.0978,
  },
  {
    id: 'chiangmai',
    name: {
      ko: '치앙마이', en: 'Chiang Mai', zh: '清迈', ja: 'チェンマイ',
      th: 'เชียงใหม่', fr: 'Chiang Mai', de: 'Chiang Mai', es: 'Chiang Mai',
    },
    description: {
      ko: '태국 북부의 문화 수도, 자연과 사원의 도시',
      en: 'The cultural capital of northern Thailand, a city of nature and temples',
      zh: '泰国北部的文化之都，自然与寺庙之城',
      ja: 'タイ北部の文化の都、自然と寺院の街',
      th: 'เมืองหลวงทางวัฒนธรรมของภาคเหนือ เมืองแห่งธรรมชาติและวัด',
      fr: 'La capitale culturelle du nord de la Thaïlande, ville de nature et de temples',
      de: 'Die Kulturhauptstadt Nordthailands, eine Stadt der Natur und Tempel',
      es: 'La capital cultural del norte de Tailandia, ciudad de naturaleza y templos',
    },
    image: '⛩️',
    lat: 18.7883,
    lng: 98.9853,
  },
];

export const courses = [
  {
    id: 'thai',
    name: {
      ko: '타이 마사지', en: 'Thai Massage', zh: '泰式按摩', ja: 'タイマッサージ',
      th: 'นวดแผนไทย', fr: 'Massage thaï', de: 'Thai-Massage', es: 'Masaje tailandés',
    },
    description: {
      ko: '전통 타이 마사지는 스트레칭과 압박을 결합하여 근육 긴장을 풀고 유연성을 향상시킵니다.',
      en: 'Traditional Thai massage combines stretching and pressure to relieve muscle tension and improve flexibility.',
      zh: '传统泰式按摩结合拉伸和按压，缓解肌肉紧张，提高柔韧性。',
      ja: '伝統的なタイマッサージはストレッチと圧力を組み合わせ、筋肉の緊張を和らげ柔軟性を向上させます。',
      th: 'นวดแผนไทยผสมผสานการยืดเหยียดและการกดจุด ช่วยคลายความตึงของกล้ามเนื้อและเพิ่มความยืดหยุ่น',
      fr: 'Le massage thaï traditionnel combine étirements et pression pour soulager les tensions musculaires et améliorer la flexibilité.',
      de: 'Die traditionelle Thai-Massage kombiniert Dehnung und Druck, um Muskelverspannungen zu lösen und die Flexibilität zu verbessern.',
      es: 'El masaje tailandés tradicional combina estiramientos y presión para aliviar la tensión muscular y mejorar la flexibilidad.',
    },
    icon: '🙏',
    options: [
      { duration: 60, price: 800 },
      { duration: 90, price: 1100 },
      { duration: 120, price: 1400 },
    ],
  },
  {
    id: 'aroma',
    name: {
      ko: '아로마 마사지', en: 'Aroma Massage', zh: '香薰按摩', ja: 'アロママッサージ',
      th: 'นวดอโรมา', fr: 'Massage aromatique', de: 'Aroma-Massage', es: 'Masaje aromático',
    },
    description: {
      ko: '에센셜 오일을 사용한 아로마테라피 마사지로 심신의 긴장을 해소하고 깊은 이완을 경험하세요.',
      en: 'Experience deep relaxation with aromatherapy massage using essential oils to relieve body and mind tension.',
      zh: '使用精油的芳香疗法按摩，舒缓身心紧张，体验深度放松。',
      ja: 'エッセンシャルオイルを使用したアロマテラピーマッサージで心身の緊張を解き、深いリラクゼーションを体験してください。',
      th: 'สัมผัสการผ่อนคลายอย่างล้ำลึกด้วยนวดอโรมาเทอราพีด้วยน้ำมันหอมระเหย คลายความตึงเครียดทั้งกายและใจ',
      fr: 'Découvrez une relaxation profonde avec un massage aux huiles essentielles pour libérer les tensions du corps et de l\'esprit.',
      de: 'Erleben Sie tiefe Entspannung mit Aromatherapie-Massage mit ätherischen Ölen zur Linderung von Körper- und Geistverspannungen.',
      es: 'Experimenta una relajación profunda con masaje de aromaterapia usando aceites esenciales para aliviar la tensión corporal y mental.',
    },
    icon: '🌸',
    options: [
      { duration: 60, price: 1000 },
      { duration: 90, price: 1400 },
      { duration: 120, price: 1800 },
    ],
  },
  {
    id: 'swedish',
    name: {
      ko: '스웨디시 마사지', en: 'Swedish Massage', zh: '瑞典式按摩', ja: 'スウェディッシュマッサージ',
      th: 'นวดสวีดิช', fr: 'Massage suédois', de: 'Schwedische Massage', es: 'Masaje sueco',
    },
    description: {
      ko: '부드러운 롱 스트로크와 니딩 기법으로 전신 이완과 혈액순환 개선에 효과적입니다.',
      en: 'Effective for full-body relaxation and improved circulation using gentle long strokes and kneading techniques.',
      zh: '通过轻柔的长推和揉捏技法，有效实现全身放松和改善血液循环。',
      ja: '優しいロングストロークとニーディング技法で全身のリラクゼーションと血行改善に効果的です。',
      th: 'มีประสิทธิภาพในการผ่อนคลายทั้งร่างกายและปรับปรุงการไหลเวียนโลหิตด้วยเทคนิคการลูบยาวและการนวดคลึง',
      fr: 'Efficace pour la relaxation du corps entier et l\'amélioration de la circulation grâce à des mouvements longs et doux et des techniques de pétrissage.',
      de: 'Effektiv für Ganzkörperentspannung und verbesserte Durchblutung durch sanfte lange Streichungen und Knettechniken.',
      es: 'Efectivo para la relajación corporal completa y mejora de la circulación con técnicas de movimientos largos suaves y amasado.',
    },
    icon: '💆',
    options: [
      { duration: 60, price: 1200 },
      { duration: 90, price: 1700 },
      { duration: 120, price: 2200 },
    ],
  },
];

export const therapists = [
  // Pattaya
  {
    id: 1,
    name: 'Somchai',
    nameKo: {
      ko: '솜차이', en: 'Somchai', zh: '颂猜', ja: 'ソムチャイ',
      th: 'สมชาย', fr: 'Somchai', de: 'Somchai', es: 'Somchai',
    },
    age: 28,
    experience: 6,
    location: 'pattaya',
    specialties: ['thai', 'aroma'],
    bio: {
      ko: '6년간의 경험으로 전통 타이 마사지와 아로마 테라피를 전문으로 합니다.',
      en: 'Specializes in traditional Thai massage and aromatherapy with 6 years of experience.',
      zh: '拥有6年经验，专注于传统泰式按摩和芳香疗法。',
      ja: '6年の経験を持ち、伝統的なタイマッサージとアロマテラピーを専門としています。',
      th: 'เชี่ยวชาญด้านนวดแผนไทยดั้งเดิมและอโรมาเทอราพีด้วยประสบการณ์ 6 ปี',
      fr: 'Spécialisé en massage thaï traditionnel et aromathérapie avec 6 ans d\'expérience.',
      de: 'Spezialisiert auf traditionelle Thai-Massage und Aromatherapie mit 6 Jahren Erfahrung.',
      es: 'Especializado en masaje tailandés tradicional y aromaterapia con 6 años de experiencia.',
    },
    rating: 4.9,
    photo: null,
    height: 170,
    weight: 62,
    features: {
      ko: '강한 압력, 스트레칭 전문',
      en: 'Strong pressure, stretching specialist',
      zh: '力度强，擅长拉伸',
      ja: '強い圧力、ストレッチ専門',
      th: 'แรงกดแข็งแรง เชี่ยวชาญการยืดเหยียด',
      fr: 'Pression forte, spécialiste étirements',
      de: 'Starker Druck, Dehnungsspezialist',
      es: 'Presión fuerte, especialista en estiramientos',
    },
  },
  {
    id: 2,
    name: 'Nari',
    nameKo: {
      ko: '나리', en: 'Nari', zh: '纳丽', ja: 'ナリ',
      th: 'นารี', fr: 'Nari', de: 'Nari', es: 'Nari',
    },
    age: 25,
    experience: 4,
    location: 'pattaya',
    specialties: ['aroma', 'swedish'],
    bio: {
      ko: '부드럽고 섬세한 터치로 고객님의 피로를 풀어드립니다.',
      en: 'Relieves your fatigue with a gentle and delicate touch.',
      zh: '以温柔细腻的手法为您消除疲劳。',
      ja: '優しく繊細なタッチでお客様の疲れを癒します。',
      th: 'ผ่อนคลายความเหนื่อยล้าของคุณด้วยสัมผัสที่นุ่มนวลและละเอียดอ่อน',
      fr: 'Soulage votre fatigue avec un toucher doux et délicat.',
      de: 'Lindert Ihre Müdigkeit mit sanfter und feinfühliger Berührung.',
      es: 'Alivia tu fatiga con un toque suave y delicado.',
    },
    rating: 4.8,
    photo: null,
    height: 160,
    weight: 50,
    features: {
      ko: '부드러운 터치, 섬세한 케어',
      en: 'Gentle touch, delicate care',
      zh: '温柔手法，细致呵护',
      ja: '優しいタッチ、繊細なケア',
      th: 'สัมผัสนุ่มนวล ดูแลอย่างละเอียดอ่อน',
      fr: 'Toucher doux, soins délicats',
      de: 'Sanfte Berührung, feinfühlige Pflege',
      es: 'Toque suave, cuidado delicado',
    },
  },
  {
    id: 3,
    name: 'Pim',
    nameKo: {
      ko: '핌', en: 'Pim', zh: '萍', ja: 'ピム',
      th: 'พิม', fr: 'Pim', de: 'Pim', es: 'Pim',
    },
    age: 30,
    experience: 8,
    location: 'pattaya',
    specialties: ['thai', 'swedish'],
    bio: {
      ko: '8년 경력의 베테랑 테라피스트로 깊은 근육 이완에 전문입니다.',
      en: 'A veteran therapist with 8 years of experience specializing in deep muscle relaxation.',
      zh: '8年经验的资深理疗师，专注于深层肌肉放松。',
      ja: '8年のキャリアを持つベテランセラピストで、深い筋肉のリラクゼーションを専門としています。',
      th: 'นักบำบัดผู้ช่ำชองด้วยประสบการณ์ 8 ปี เชี่ยวชาญการคลายกล้ามเนื้อระดับลึก',
      fr: 'Thérapeute vétéran avec 8 ans d\'expérience, spécialisé dans la relaxation musculaire profonde.',
      de: 'Erfahrener Therapeut mit 8 Jahren Erfahrung, spezialisiert auf tiefe Muskelentspannung.',
      es: 'Terapeuta veterano con 8 años de experiencia, especializado en relajación muscular profunda.',
    },
    rating: 4.7,
    photo: null,
    height: 168,
    weight: 65,
    features: {
      ko: '딥티슈 전문, 강한 근육 이완',
      en: 'Deep tissue specialist, strong muscle relief',
      zh: '深层组织专家，强力肌肉放松',
      ja: 'ディープティシュー専門、強力な筋肉弛緩',
      th: 'เชี่ยวชาญดีพทิชชู่ คลายกล้ามเนื้อเข้มข้น',
      fr: 'Spécialiste tissus profonds, soulagement musculaire',
      de: 'Tiefengewebe-Spezialist, starke Muskelentspannung',
      es: 'Especialista en tejido profundo, alivio muscular intenso',
    },
  },
  // Phuket
  {
    id: 4,
    name: 'Kai',
    nameKo: {
      ko: '카이', en: 'Kai', zh: '凯', ja: 'カイ',
      th: 'ไก่', fr: 'Kai', de: 'Kai', es: 'Kai',
    },
    age: 27,
    experience: 5,
    location: 'phuket',
    specialties: ['thai', 'aroma'],
    bio: {
      ko: '푸켓의 자연 속에서 힐링 마사지를 제공합니다.',
      en: 'Provides healing massage in the natural beauty of Phuket.',
      zh: '在普吉岛的自然环境中提供疗愈按摩。',
      ja: 'プーケットの自然の中でヒーリングマッサージを提供します。',
      th: 'ให้บริการนวดเพื่อการเยียวยาในธรรมชาติอันสวยงามของภูเก็ต',
      fr: 'Propose des massages de guérison dans la beauté naturelle de Phuket.',
      de: 'Bietet heilende Massage in der natürlichen Schönheit von Phuket.',
      es: 'Ofrece masaje curativo en la belleza natural de Phuket.',
    },
    rating: 4.9,
    photo: null,
    height: 165,
    weight: 58,
    features: {
      ko: '힐링 마사지, 자연 요법',
      en: 'Healing massage, natural therapy',
      zh: '疗愈按摩，自然疗法',
      ja: 'ヒーリングマッサージ、自然療法',
      th: 'นวดเพื่อการเยียวยา ธรรมชาติบำบัด',
      fr: 'Massage guérison, thérapie naturelle',
      de: 'Heilende Massage, Naturtherapie',
      es: 'Masaje curativo, terapia natural',
    },
  },
  {
    id: 5,
    name: 'Mali',
    nameKo: {
      ko: '말리', en: 'Mali', zh: '玛丽', ja: 'マリ',
      th: 'มะลิ', fr: 'Mali', de: 'Mali', es: 'Mali',
    },
    age: 32,
    experience: 10,
    location: 'phuket',
    specialties: ['aroma', 'swedish'],
    bio: {
      ko: '10년 이상의 경력으로 최고의 아로마 테라피를 선사합니다.',
      en: 'Delivers the finest aromatherapy with over 10 years of experience.',
      zh: '凭借超过10年的经验，提供最优质的芳香疗法。',
      ja: '10年以上のキャリアで最高のアロマテラピーを提供します。',
      th: 'มอบอโรมาเทอราพีชั้นเลิศด้วยประสบการณ์กว่า 10 ปี',
      fr: 'Offre la meilleure aromathérapie avec plus de 10 ans d\'expérience.',
      de: 'Bietet die beste Aromatherapie mit über 10 Jahren Erfahrung.',
      es: 'Ofrece la mejor aromaterapia con más de 10 años de experiencia.',
    },
    rating: 5.0,
    photo: null,
    height: 163,
    weight: 55,
    features: {
      ko: '아로마 전문, 프리미엄 에센셜 오일',
      en: 'Aroma specialist, premium essential oils',
      zh: '芳香专家，优质精油',
      ja: 'アロマ専門、プレミアムエッセンシャルオイル',
      th: 'เชี่ยวชาญอโรมา น้ำมันหอมระเหยพรีเมียม',
      fr: 'Spécialiste arômes, huiles essentielles premium',
      de: 'Aroma-Spezialistin, Premium-Ätherische Öle',
      es: 'Especialista en aromas, aceites esenciales premium',
    },
  },
  {
    id: 6,
    name: 'Dao',
    nameKo: {
      ko: '다오', en: 'Dao', zh: '道', ja: 'ダオ',
      th: 'ดาว', fr: 'Dao', de: 'Dao', es: 'Dao',
    },
    age: 26,
    experience: 4,
    location: 'phuket',
    specialties: ['thai'],
    bio: {
      ko: '정통 타이 마사지의 기술을 완벽하게 구사합니다.',
      en: 'Perfectly masters the techniques of authentic Thai massage.',
      zh: '完美掌握正宗泰式按摩技术。',
      ja: '本格的なタイマッサージの技術を完璧に使いこなします。',
      th: 'เชี่ยวชาญเทคนิคนวดแผนไทยแท้ๆ อย่างสมบูรณ์แบบ',
      fr: 'Maîtrise parfaitement les techniques du massage thaï authentique.',
      de: 'Beherrscht die Techniken der authentischen Thai-Massage perfekt.',
      es: 'Domina perfectamente las técnicas del auténtico masaje tailandés.',
    },
    rating: 4.6,
    photo: null,
    height: 158,
    weight: 48,
    features: {
      ko: '정통 기법, 정확한 압점',
      en: 'Authentic technique, precise pressure points',
      zh: '正宗技法，精准穴位',
      ja: '本格的な技法、正確な圧点',
      th: 'เทคนิคแท้ จุดกดแม่นยำ',
      fr: 'Technique authentique, points de pression précis',
      de: 'Authentische Technik, präzise Druckpunkte',
      es: 'Técnica auténtica, puntos de presión precisos',
    },
  },
  {
    id: 7,
    name: 'Ploy',
    nameKo: {
      ko: '플로이', en: 'Ploy', zh: '普洛伊', ja: 'プロイ',
      th: 'พลอย', fr: 'Ploy', de: 'Ploy', es: 'Ploy',
    },
    age: 29,
    experience: 7,
    location: 'phuket',
    specialties: ['swedish', 'aroma'],
    bio: {
      ko: '스웨디시와 아로마를 결합한 특별한 마사지를 제공합니다.',
      en: 'Provides a special massage combining Swedish and aroma techniques.',
      zh: '提供结合瑞典式和芳香技法的特别按摩。',
      ja: 'スウェディッシュとアロマを組み合わせた特別なマッサージを提供します。',
      th: 'ให้บริการนวดพิเศษที่ผสมผสานเทคนิคสวีดิชและอโรมา',
      fr: 'Propose un massage spécial combinant les techniques suédoises et aromatiques.',
      de: 'Bietet eine spezielle Massage, die schwedische und Aroma-Techniken kombiniert.',
      es: 'Ofrece un masaje especial que combina técnicas suecas y aromáticas.',
    },
    rating: 4.8,
    photo: null,
    height: 166,
    weight: 56,
    features: {
      ko: '복합 기법, 맞춤형 프로그램',
      en: 'Combined techniques, customized programs',
      zh: '综合技法，定制方案',
      ja: '複合技法、カスタマイズプログラム',
      th: 'เทคนิคผสมผสาน โปรแกรมปรับแต่งตามความต้องการ',
      fr: 'Techniques combinées, programmes personnalisés',
      de: 'Kombinierte Techniken, individuelle Programme',
      es: 'Técnicas combinadas, programas personalizados',
    },
  },
  // Bangkok
  {
    id: 8,
    name: 'Noon',
    nameKo: {
      ko: '눈', en: 'Noon', zh: '暖', ja: 'ヌーン',
      th: 'นุ่น', fr: 'Noon', de: 'Noon', es: 'Noon',
    },
    age: 31,
    experience: 9,
    location: 'bangkok',
    specialties: ['thai', 'aroma', 'swedish'],
    bio: {
      ko: '방콕 최고의 스파에서 9년간 근무한 경력을 보유하고 있습니다.',
      en: 'Has 9 years of experience working at Bangkok\'s top spas.',
      zh: '拥有在曼谷顶级水疗中心工作9年的经验。',
      ja: 'バンコクのトップスパで9年間勤務した経験を持っています。',
      th: 'มีประสบการณ์ 9 ปีจากการทำงานในสปาชั้นนำของกรุงเทพฯ',
      fr: 'Possède 9 ans d\'expérience dans les meilleurs spas de Bangkok.',
      de: 'Hat 9 Jahre Erfahrung in Bangkoks besten Spas.',
      es: 'Tiene 9 años de experiencia trabajando en los mejores spas de Bangkok.',
    },
    rating: 4.9,
    photo: null,
    height: 172,
    weight: 64,
    features: {
      ko: '올라운더, 모든 코스 가능',
      en: 'All-rounder, all courses available',
      zh: '全能型，所有课程均可',
      ja: 'オールラウンダー、全コース対応',
      th: 'รอบด้าน ให้บริการได้ทุกคอร์ส',
      fr: 'Polyvalent, tous les cours disponibles',
      de: 'Allrounder, alle Kurse verfügbar',
      es: 'Todoterreno, todos los cursos disponibles',
    },
  },
  {
    id: 9,
    name: 'Fah',
    nameKo: {
      ko: '파', en: 'Fah', zh: '法', ja: 'ファー',
      th: 'ฟ้า', fr: 'Fah', de: 'Fah', es: 'Fah',
    },
    age: 24,
    experience: 3,
    location: 'bangkok',
    specialties: ['aroma'],
    bio: {
      ko: '젊은 감각으로 트렌디한 아로마 테라피를 선보입니다.',
      en: 'Brings trendy aromatherapy with a youthful touch.',
      zh: '以年轻的感觉呈现时尚的芳香疗法。',
      ja: '若い感性でトレンディなアロマテラピーをお届けします。',
      th: 'นำเสนออโรมาเทอราพีสไตล์ใหม่ด้วยสัมผัสวัยรุ่น',
      fr: 'Propose une aromathérapie tendance avec une touche jeune.',
      de: 'Bringt trendige Aromatherapie mit jugendlicher Note.',
      es: 'Ofrece aromaterapia moderna con un toque juvenil.',
    },
    rating: 4.5,
    photo: null,
    height: 157,
    weight: 47,
    features: {
      ko: '트렌디한 아로마, 젊은 감각',
      en: 'Trendy aroma, youthful style',
      zh: '时尚芳香，年轻风格',
      ja: 'トレンディなアロマ、若い感性',
      th: 'อโรมาสไตล์ใหม่ สไตล์วัยรุ่น',
      fr: 'Arômes tendance, style jeune',
      de: 'Trendige Aromen, jugendlicher Stil',
      es: 'Aromas de moda, estilo juvenil',
    },
  },
  {
    id: 10,
    name: 'Bua',
    nameKo: {
      ko: '부아', en: 'Bua', zh: '布阿', ja: 'ブア',
      th: 'บัว', fr: 'Bua', de: 'Bua', es: 'Bua',
    },
    age: 33,
    experience: 11,
    location: 'bangkok',
    specialties: ['thai', 'swedish'],
    bio: {
      ko: '11년 경력의 마스터 테라피스트입니다. 깊은 이완을 경험하세요.',
      en: 'A master therapist with 11 years of experience. Experience deep relaxation.',
      zh: '11年经验的大师级理疗师。体验深度放松。',
      ja: '11年のキャリアを持つマスターセラピストです。深いリラクゼーションを体験してください。',
      th: 'นักบำบัดระดับมาสเตอร์ด้วยประสบการณ์ 11 ปี สัมผัสการผ่อนคลายอย่างล้ำลึก',
      fr: 'Thérapeute maître avec 11 ans d\'expérience. Découvrez une relaxation profonde.',
      de: 'Master-Therapeut mit 11 Jahren Erfahrung. Erleben Sie tiefe Entspannung.',
      es: 'Terapeuta maestro con 11 años de experiencia. Experimenta una relajación profunda.',
    },
    rating: 5.0,
    photo: null,
    height: 175,
    weight: 68,
    features: {
      ko: '마스터급, 깊은 이완 전문',
      en: 'Master level, deep relaxation specialist',
      zh: '大师级，深度放松专家',
      ja: 'マスターレベル、深いリラクゼーション専門',
      th: 'ระดับมาสเตอร์ เชี่ยวชาญการผ่อนคลายระดับลึก',
      fr: 'Niveau maître, spécialiste relaxation profonde',
      de: 'Meisterniveau, Tiefenentspannung-Spezialist',
      es: 'Nivel maestro, especialista en relajación profunda',
    },
  },
  {
    id: 11,
    name: 'Joy',
    nameKo: {
      ko: '조이', en: 'Joy', zh: '乔伊', ja: 'ジョイ',
      th: 'จอย', fr: 'Joy', de: 'Joy', es: 'Joy',
    },
    age: 27,
    experience: 5,
    location: 'bangkok',
    specialties: ['swedish', 'aroma'],
    bio: {
      ko: '스웨디시 마사지 전문가로 세심한 케어를 약속합니다.',
      en: 'A Swedish massage specialist who promises attentive care.',
      zh: '瑞典式按摩专家，承诺细心呵护。',
      ja: 'スウェディッシュマッサージの専門家として丁寧なケアをお約束します。',
      th: 'ผู้เชี่ยวชาญนวดสวีดิชที่ให้การดูแลอย่างเอาใจใส่',
      fr: 'Spécialiste du massage suédois qui promet des soins attentionnés.',
      de: 'Schwedische Massage-Spezialistin, die aufmerksame Pflege verspricht.',
      es: 'Especialista en masaje sueco que promete un cuidado atento.',
    },
    rating: 4.7,
    photo: null,
    height: 162,
    weight: 53,
    features: {
      ko: '세심한 케어, 리듬감 있는 터치',
      en: 'Attentive care, rhythmic touch',
      zh: '细心呵护，节奏感手法',
      ja: '丁寧なケア、リズミカルなタッチ',
      th: 'ดูแลเอาใจใส่ สัมผัสเป็นจังหวะ',
      fr: 'Soins attentifs, toucher rythmique',
      de: 'Aufmerksame Pflege, rhythmische Berührung',
      es: 'Cuidado atento, toque rítmico',
    },
  },
  // Korat
  {
    id: 12,
    name: 'Lek',
    nameKo: {
      ko: '렉', en: 'Lek', zh: '乐', ja: 'レック',
      th: 'เล็ก', fr: 'Lek', de: 'Lek', es: 'Lek',
    },
    age: 29,
    experience: 7,
    location: 'korat',
    specialties: ['thai', 'aroma'],
    bio: {
      ko: '코랏에서 가장 인기 있는 테라피스트입니다.',
      en: 'The most popular therapist in Korat.',
      zh: '呵叻最受欢迎的理疗师。',
      ja: 'コラートで最も人気のあるセラピストです。',
      th: 'นักบำบัดที่ได้รับความนิยมสูงสุดในโคราช',
      fr: 'Le thérapeute le plus populaire de Korat.',
      de: 'Der beliebteste Therapeut in Korat.',
      es: 'El terapeuta más popular de Korat.',
    },
    rating: 4.8,
    photo: null,
    height: 167,
    weight: 60,
    features: {
      ko: '인기 1위, 친절한 서비스',
      en: 'Most popular, friendly service',
      zh: '人气第一，友好服务',
      ja: '人気No.1、フレンドリーなサービス',
      th: 'ยอดนิยมอันดับ 1 บริการเป็นมิตร',
      fr: 'Le plus populaire, service amical',
      de: 'Beliebtester, freundlicher Service',
      es: 'Más popular, servicio amigable',
    },
  },
  {
    id: 13,
    name: 'Wan',
    nameKo: {
      ko: '완', en: 'Wan', zh: '万', ja: 'ワン',
      th: 'วรรณ', fr: 'Wan', de: 'Wan', es: 'Wan',
    },
    age: 26,
    experience: 4,
    location: 'korat',
    specialties: ['thai'],
    bio: {
      ko: '전통 타이 마사지의 정수를 보여드립니다.',
      en: 'Shows you the essence of traditional Thai massage.',
      zh: '为您展示传统泰式按摩的精髓。',
      ja: '伝統的なタイマッサージの真髄をお見せします。',
      th: 'แสดงให้คุณเห็นแก่นแท้ของนวดแผนไทยดั้งเดิม',
      fr: 'Vous montre l\'essence du massage thaï traditionnel.',
      de: 'Zeigt Ihnen die Essenz der traditionellen Thai-Massage.',
      es: 'Le muestra la esencia del masaje tailandés tradicional.',
    },
    rating: 4.6,
    photo: null,
    height: 164,
    weight: 54,
    features: {
      ko: '정통파, 전통 기법 고수',
      en: 'Traditionalist, authentic techniques',
      zh: '传统派，正宗技法',
      ja: '正統派、伝統技法の達人',
      th: 'สายดั้งเดิม เทคนิคแท้จริง',
      fr: 'Traditionaliste, techniques authentiques',
      de: 'Traditionalist, authentische Techniken',
      es: 'Tradicionalista, técnicas auténticas',
    },
  },
  {
    id: 14,
    name: 'Ning',
    nameKo: {
      ko: '닝', en: 'Ning', zh: '宁', ja: 'ニン',
      th: 'นิ่ง', fr: 'Ning', de: 'Ning', es: 'Ning',
    },
    age: 30,
    experience: 8,
    location: 'korat',
    specialties: ['aroma', 'swedish'],
    bio: {
      ko: '8년간의 노하우로 최상의 릴렉싱 마사지를 제공합니다.',
      en: 'Provides the best relaxing massage with 8 years of expertise.',
      zh: '凭借8年的专业经验，提供最优质的放松按摩。',
      ja: '8年のノウハウで最高のリラクシングマッサージを提供します。',
      th: 'ให้บริการนวดผ่อนคลายชั้นเลิศด้วยความเชี่ยวชาญ 8 ปี',
      fr: 'Offre le meilleur massage relaxant avec 8 ans de savoir-faire.',
      de: 'Bietet die beste entspannende Massage mit 8 Jahren Expertise.',
      es: 'Ofrece el mejor masaje relajante con 8 años de experiencia.',
    },
    rating: 4.9,
    photo: null,
    height: 169,
    weight: 59,
    features: {
      ko: '릴렉싱 전문, 스트레스 해소',
      en: 'Relaxation specialist, stress relief',
      zh: '放松专家，减压',
      ja: 'リラクゼーション専門、ストレス解消',
      th: 'เชี่ยวชาญการผ่อนคลาย คลายเครียด',
      fr: 'Spécialiste relaxation, anti-stress',
      de: 'Entspannungsspezialistin, Stressabbau',
      es: 'Especialista en relajación, alivio del estrés',
    },
  },
  // Chiang Mai
  {
    id: 15,
    name: 'Aom',
    nameKo: {
      ko: '옴', en: 'Aom', zh: '奥姆', ja: 'オム',
      th: 'อ้อม', fr: 'Aom', de: 'Aom', es: 'Aom',
    },
    age: 28,
    experience: 6,
    location: 'chiangmai',
    specialties: ['thai', 'aroma'],
    bio: {
      ko: '치앙마이의 전통 란나 스타일 마사지를 전문으로 합니다.',
      en: 'Specializes in traditional Lanna-style massage from Chiang Mai.',
      zh: '专注于清迈传统兰纳风格按摩。',
      ja: 'チェンマイの伝統的なランナースタイルマッサージを専門としています。',
      th: 'เชี่ยวชาญนวดแบบล้านนาดั้งเดิมของเชียงใหม่',
      fr: 'Spécialisé dans le massage traditionnel de style Lanna de Chiang Mai.',
      de: 'Spezialisiert auf traditionelle Lanna-Massage aus Chiang Mai.',
      es: 'Especializado en masaje tradicional estilo Lanna de Chiang Mai.',
    },
    rating: 4.9,
    photo: null,
    height: 161,
    weight: 52,
    features: {
      ko: '란나 전통 마사지, 허브 요법',
      en: 'Lanna traditional massage, herbal therapy',
      zh: '兰纳传统按摩，草药疗法',
      ja: 'ランナー伝統マッサージ、ハーブ療法',
      th: 'นวดล้านนาดั้งเดิม สมุนไพรบำบัด',
      fr: 'Massage Lanna traditionnel, phytothérapie',
      de: 'Lanna-Traditionsmassage, Kräutertherapie',
      es: 'Masaje tradicional Lanna, fitoterapia',
    },
  },
  {
    id: 16,
    name: 'Tarn',
    nameKo: {
      ko: '탄', en: 'Tarn', zh: '塔恩', ja: 'ターン',
      th: 'ตาล', fr: 'Tarn', de: 'Tarn', es: 'Tarn',
    },
    age: 31,
    experience: 9,
    location: 'chiangmai',
    specialties: ['swedish', 'aroma'],
    bio: {
      ko: '9년 경력으로 치앙마이 최고의 스파에서 활동하고 있습니다.',
      en: 'Active at Chiang Mai\'s best spas with 9 years of experience.',
      zh: '拥有9年经验，活跃于清迈最好的水疗中心。',
      ja: '9年の経験を持ちチェンマイ最高のスパで活動しています。',
      th: 'ทำงานในสปาชั้นนำของเชียงใหม่ด้วยประสบการณ์ 9 ปี',
      fr: 'Actif dans les meilleurs spas de Chiang Mai avec 9 ans d\'expérience.',
      de: 'Aktiv in Chiang Mais besten Spas mit 9 Jahren Erfahrung.',
      es: 'Activo en los mejores spas de Chiang Mai con 9 años de experiencia.',
    },
    rating: 4.8,
    photo: null,
    height: 170,
    weight: 63,
    features: {
      ko: '스파 경력자, 프리미엄 서비스',
      en: 'Spa veteran, premium service',
      zh: '水疗资深，优质服务',
      ja: 'スパ経験者、プレミアムサービス',
      th: 'ผู้ช่ำชองจากสปา บริการระดับพรีเมียม',
      fr: 'Vétéran spa, service premium',
      de: 'Spa-Veteran, Premium-Service',
      es: 'Veterano de spa, servicio premium',
    },
  },
  {
    id: 17,
    name: 'Mint',
    nameKo: {
      ko: '민트', en: 'Mint', zh: '明特', ja: 'ミント',
      th: 'มิ้นท์', fr: 'Mint', de: 'Mint', es: 'Mint',
    },
    age: 26,
    experience: 5,
    location: 'chiangmai',
    specialties: ['thai', 'swedish'],
    bio: {
      ko: '자연 속 힐링과 깊은 근육 이완을 결합한 마사지를 제공합니다.',
      en: 'Provides massage combining natural healing and deep muscle relaxation.',
      zh: '提供结合自然疗愈和深层肌肉放松的按摩。',
      ja: '自然の中のヒーリングと深い筋肉のリラクゼーションを組み合わせたマッサージを提供します。',
      th: 'ให้บริการนวดผสมผสานการเยียวยาตามธรรมชาติและการคลายกล้ามเนื้อระดับลึก',
      fr: 'Propose un massage alliant guérison naturelle et relaxation musculaire profonde.',
      de: 'Bietet Massage, die natürliche Heilung und tiefe Muskelentspannung kombiniert.',
      es: 'Ofrece masaje que combina sanación natural y relajación muscular profunda.',
    },
    rating: 4.7,
    photo: null,
    height: 164,
    weight: 51,
    features: {
      ko: '자연 힐링, 하이브리드 마사지',
      en: 'Natural healing, hybrid massage',
      zh: '自然疗愈，混合按摩',
      ja: '自然ヒーリング、ハイブリッドマッサージ',
      th: 'เยียวยาตามธรรมชาติ นวดแบบผสมผสาน',
      fr: 'Guérison naturelle, massage hybride',
      de: 'Natürliche Heilung, Hybrid-Massage',
      es: 'Sanación natural, masaje híbrido',
    },
  },
];
